import { useEffect, useState } from 'react';

import { APP_PUSH_EVENT, appPush, type AppPush } from './app';

/**
 * The app's device token for notifications, following the shell: null in a browser and until the person allows
 * notifications; the token as soon as the shell hands it over (apps/apple sends `bridge:push`).
 */
export function useAppPush(): AppPush | null {
  const [push, setPush] = useState<AppPush | null>(appPush);
  useEffect(() => {
    const update = (): void => {
      const next = appPush();
      setPush((current) => (current?.token === next?.token && current?.env === next?.env ? current : next));
    };
    window.addEventListener(APP_PUSH_EVENT, update);
    return () => {
      window.removeEventListener(APP_PUSH_EVENT, update);
    };
  }, []);
  return push;
}
